class Service {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $(function () {
      $('.js-acc-container').css("display", "none");
      $('.js-acc').on('click', function () {
        $(this).find('.js-acc-container').slideToggle();
        $(this).find('.ic-acc-plus').toggleClass("is-active")
      })
    });

    const swiper = new Swiper(".cp-s-swiper", {
      slidesPerView: 1,
      spaceBetween: 20,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      centeredSlides : true,
      breakpoints: {
        // スライドの表示枚数：500px以上の場合
        768: {
          spaceBetween: 0,
          slidesPerView: "auto",
          centeredSlides : false,
        }
      }

    });

    const listLink = document.querySelectorAll(".list01-txtWrap a")
    const hiddenLink = document.querySelectorAll(".hidden-link")

    if (listLink) {

      listLink.forEach((el01,num01) => {

        el01.setAttribute("target", "_blank")

        hiddenLink.forEach((el02,num02) => {

          if(num01 === num02){

            const hiddenText = el02.innerHTML
            const hiddenHref = el02.getAttribute('href')


            el01.setAttribute("href", hiddenHref)
            el01.innerHTML = hiddenText
          }

        })

      })


    }


    const accLink = document.querySelectorAll(".c-acc-inner a")
    const hiddenAccLink = document.querySelectorAll(".hidden-link02")

    // console.log(accLink[0]);


    if (accLink) {

      accLink.forEach((el01,num01) => {

        el01.setAttribute("target", "_blank")

        hiddenAccLink.forEach((el02,num02) => {

          if(num01 === num02){

            const hiddenText = el02.innerHTML
            const hiddenHref = el02.getAttribute('href')


            el01.setAttribute("href", hiddenHref)
            el01.innerHTML = hiddenText
          }

        })

      })


    }






    if(document.querySelector(".js-ps-modal")){
      const modal = document.querySelector(".js-ps-modal")
      const modalTrigger = document.querySelector(".js-mv-modal")
      const modalClose = document.querySelector(".js-modal__close")
      const body = document.querySelector("body")
      const video = document.querySelector(".js-modal-video")



      modalTrigger.addEventListener("click", ()=> {
        modal.classList.add("is-active")
        body.style.overflow = "hidden"

        if(video){
          video.play()
        }
      })

      modalClose.addEventListener("click", () => {
        modal.classList.remove("is-active")
        body.style.overflow = "auto"

        if(video){
          video.pause()
        }


      })
    }


  }
}